module.exports = __webpack_public_path__ + "img/002-sheep.3690a1ed.svg";